module.exports = __webpack_public_path__ + "img/system.6b50928a.svg";